import { NgModule } from '@angular/core';
import { RouterModule, Routes, mapToCanActivate } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { AccessDeniedComponent } from '@core/authentication/components/access-denied/access-denied.component';
import { wccRoutes } from '@core/routes';
import { MainComponent } from '@feature/main/main.component';

const routes: Routes = [
  {
    path: 'access-denied',
    component: AccessDeniedComponent,
    data: { title: 'Access Denied' }
  },
  {
    path: '',
    component: MainComponent,
    canActivate: [...mapToCanActivate([MsalGuard])],
    children: [
      ...wccRoutes,
      {
        path: 'sdoh',
        children: [
          {
            path: '**',
            loadComponent: () => import('@feature/mfe-page/mfe-page.component').then(m => m.MfePageComponent),
            data: {
              showDashboardNavigator: true,
            }
          }
        ]
      },
      {
        path: 'analytics',
        children: [
          {
            path: '**',
            loadComponent: () => import('@feature/mfe-page/mfe-page.component').then(m => m.MfePageComponent),
            data: {
              appName: 'sdoh',
              showDashboardNavigator: false,
            }
          }
        ]
      },
      {
        path: 'notifications',
        loadComponent: () => import('@feature/notifications/notifications/notifications.component').then(m => m.NotificationsComponent),
      },
    ]
  },
  {
    path: '**',
    redirectTo: ''
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
